export enum SeverityEnum {
	Success = 'Success',
	Info = 'Info',
	Error = 'Error',
}
